module.exports = __webpack_public_path__ + "static/aga-logo-be059c659766f57295d343e4a45d585a.svg";